import { apiGet } from './client';
import type { ActiveJobsResponse } from './types';

export function getActiveJobs(): Promise<ActiveJobsResponse> {
  return apiGet<ActiveJobsResponse>('/api/v1/jobs/active');
}

export function getRecentJobs(limit = 5): Promise<ActiveJobsResponse> {
  return apiGet<ActiveJobsResponse>('/api/v1/jobs/recent', { params: { limit } });
}
